import { getConfig } from 'dynamic-data/config';
export default getConfig;